export const LINK = 'link'
export const LINK_ID_AMP = 'amp-link'
export const LINK_REL_AMP = 'stylesheet'
export const LINK_SOURCE_AMP =
  '//amp.azure.net/libs/amp/2.3.8/skins/amp-flush/azuremediaplayer.min.css'
export const SCRIPT = 'script'
export const SCRIPT_ID_AMP = 'amp-script'
export const SCRIPT_SOURCE_AMP =
  '//amp.azure.net/libs/amp/2.3.8/azuremediaplayer.min.js'
